import { IoAdd } from 'react-icons/io5';

import { Button, Group, Text } from '@mantine/core';

import {
    ComponentQuery,
    ComponentType,
    ConverterCategoryOptions,
    currentConverter,
    energyConverter,
    getConverterCategory,
    powerConverter,
    voltageConverter,
} from 'models';
import { FormatHelpers } from 'helpers/formatters';

import { useComponentSearchData } from 'components/component-overview/hooks/use-component-search-data';
import { SearchService } from 'components/component-overview/services/SearchService';

export const FilterSuggestions = () => {
    const { suggestions, isLoading } = useComponentSearchData();

    if (isLoading || !suggestions?.length) {
        return null;
    }

    return (
        <Group gap={6}>
            <Text fz="xs" c="dimmed">
                Suggested filters
            </Text>
            {suggestions.map(({ filter, count }, index) => (
                <Button
                    key={label(filter)}
                    size="compact-xs"
                    variant="default"
                    radius="xl"
                    leftSection={<IoAdd />}
                    styles={{ root: { borderStyle: 'dashed' } }}
                    onClick={() => SearchService.pickSuggestion({ filter, count }, index + 1)}
                >
                    {label(filter)}
                    <Text span inherit c="dimmed" ml={4}>
                        {count}
                    </Text>
                </Button>
            ))}
        </Group>
    );
};

const label = ({ type, ports, maxPorts, ratings, energyCapacity }: Partial<ComponentQuery>) => {
    const category = ports?.length ? getConverterCategory(ports, maxPorts) : undefined;

    if (category) {
        return ConverterCategoryOptions.find(({ value }) => value === category)?.label ?? category;
    }

    if (type) {
        return ComponentType.options.find(({ value }) => value === type)?.label ?? type;
    }

    if (ratings?.power?.min) {
        return `≥ ${FormatHelpers.formatValue(ratings.power.min, powerConverter)}`;
    }

    if (ratings?.voltage?.min) {
        return `≥ ${FormatHelpers.formatValue(ratings.voltage.min, voltageConverter)}`;
    }

    if (ratings?.current?.min) {
        return `≥ ${FormatHelpers.formatValue(ratings.current.min, currentConverter)}`;
    }

    if (energyCapacity?.value) {
        return `≥ ${FormatHelpers.formatValue(energyCapacity.value, energyConverter, energyCapacity.unit)}`;
    }

    return '';
};
